import React, { useMemo } from "react";
import { useData } from "../../context/DataContext";
import { useAuth } from "../../context/AuthContext";
import { userMatchesField, cellText } from "../../utils/helpers";
import TaskTable from "../../components/TaskTable";
import { USER_TABLE } from "../../context/DataContext";

export default function CompletedTasks() {
  const { userRecords, adminRecords, loading } = useData();
  const { user } = useAuth();

  // Build lookup: admin task fully done (all users completed)?
  const adminDoneMap = useMemo(() => {
    const m = {};
    for (const ar of adminRecords) {
      const tid = cellText(ar.fields?.["Task ID"]);
      if (!tid || tid === "—") continue;
      const st = cellText(ar.fields?.["Overall Status"]).toLowerCase();
      m[tid] = st.includes("done") || st.includes("✅");
    }
    return m;
  }, [adminRecords]);

  const completed = useMemo(() =>
    userRecords.filter((r) => {
      const isMine = r.user_id === user?.userId;
      if (!isMine) return false;
      const tid = cellText(r.fields?.["Task ID"]);
      // Only show in Completed when ALL assigned users have finished
      return !!adminDoneMap[tid];
    }),
    [userRecords, user, adminDoneMap]
  );

  if (loading && userRecords.length === 0) return <div className="loading-box"><div className="spinner" /><span>Loading...</span></div>;

  return (
    <div className="fade-in">
      <TaskTable
        title="✅ Completed Tasks"
        tableId={USER_TABLE}
        records={completed}
        emptyMsg="No completed tasks yet. Keep going! 💪"
        hideStatusFilter
        kanbanLayout="completedDate"
        canComplete
      />
    </div>
  );
}
